import { create } from 'zustand';

type HeroScrollAnimationState = {
  progress: number;
};

export const useHeroScrollAnimation = create<HeroScrollAnimationState>(() => ({
  progress: 0,
}));
